export default "__VITE_ASSET__Zu7qZvjg__"